import { EntityActionTypeSelectOptionValue } from '../../../Entity'

export const ITEM_ACTION_TYPES = [
  EntityActionTypeSelectOptionValue.Edit,
  EntityActionTypeSelectOptionValue.RemoveAll,
]
